import { useGoTo as useVuetifyGoTo } from 'vuetify'

export default function useGoTo() {
  const goTo = useVuetifyGoTo()
  return goTo
}
